module.exports = __webpack_public_path__ + "img/data.715f091.svg";